/** Default Monte-Carlo iteration count (ENGINE_DESIGN §5: "10k iterations default"). */
export const DEFAULT_MC_ITERATIONS = 10_000;
/** Default exact-vs-MC ops gate for hand-vs-range (ENGINE_DESIGN §5: "~2M ops"). */
export const DEFAULT_EXACT_THRESHOLD = 2_000_000;
//# sourceMappingURL=types.js.map